<template>
  <section>
    <div v-if="user.isAdmin">
      <b-upload v-model="dropFile">
        <a class="button is-primary">
          <b-icon icon="upload"></b-icon>
          <span>อัปโหลดเอกสาร</span>
        </a>
      </b-upload>
      <button
        class="button is-danger"
        :disabled="!checkedRows.length"
        @click="deleteDocuments"
      >
        ลบ
      </button>
    </div>
    <b-table
      :data="documents"
      :checked-rows.sync="checkedRows"
      focusable
      :checkable="user.isAdmin"
    >
      <template slot-scope="props">
        <b-table-column field="name" label="ชื่อเอกสาร">
          <a v-bind:href="props.row.src">
            {{ props.row.name }}
          </a>
        </b-table-column>
        <b-table-column field="createdAt" label="วันที่สร้าง">
          {{ props.row.createdAt.toDate().toLocaleDateString() }}
        </b-table-column>
      </template>
    </b-table>
    <b-loading
      :is-full-page="isFullPage"
      :active.sync="isLoading"
      :can-cancel="false"
    ></b-loading>
  </section>
</template>
<script>
import firebase from "firebase";
import { db } from "@/main";
import { Promise } from "q";

firebase.storage().ref("/documents").constructor.prototype.putFiles = function(
  file
) {
  let ref = this;
  let userId = firebase.auth().currentUser.uid;
  return db
    .collection("documents")
    .add({
      name: file.name,
      createdAt: new Date(),
      userId: userId
    })
    .then(fileRef => {
      // let fileId = fileRef.id;
      return ref
        .child("documents/" + file.name)
        .put(file)
        .then(snapshot => {
          return snapshot.ref.getDownloadURL();
        })
        .then(downloadUrl => {
          return fileRef.update({ src: downloadUrl }).then(() => downloadUrl);
        });
    });
};

export default {
  name: "download",
  watch: {
    dropFile: function(newFile, oldFile) {
      if (newFile != null && newFile != oldFile) {
        this.isLoading = true;
        firebase
          .storage()
          .ref()
          .putFiles(newFile)
          .then(() => {
            this.dropFile = null;
            this.isLoading = false;
          });
      }
    }
  },
  data: function() {
    return {
      dropFile: null,
      isLoading: false,
      selected: null,
      checkedRows: [],
      isFullPage: true,
      user: this.$store.state.currentUser
    };
  },
  firestore() {
    return {
      documents: db.collection("documents").orderBy("createdAt", "desc")
    };
  },
  methods: {
    deleteDocuments() {
      this.isLoading = true;
      let deletePros = this.checkedRows.map(function(document) {
        let fileRef = firebase
          .storage()
          .ref()
          .child("documents/" + document.name);
        return fileRef
          .delete()
          .then(function() {
            return db
              .collection("documents")
              .doc(document.id)
              .delete();
          })
          .catch(function(error) {
            console.log(error);
          });
      });

      return Promise.all(deletePros).then(() => {
        this.isLoading = false;
      });
    }
  }
};
</script>
<style scoped>
section {
  margin: 10px;
}
button.is-primary {
  margin-right: 5px;
}
</style>
